import styled from 'styled-components';
import { DivA11y } from 'utils/a11y-utils';

export const Header = styled.div`
  width: 100%;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 0.5px solid #cfd7df;
  background: white;
  z-index: 1;
  & > div.close {
    cursor: pointer;
    display: grid;
    place-content: center;
  }
  & > div.heading {
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    color: var(--color-elephant-850);
  }
`;

export const Container = styled(DivA11y)`
  width: 415px;
  height: 250px;
  background: #ffffff;
  box-shadow: 0px 14px 24px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  div.pl-menu-items {
    overflow: auto;
    flex: 1;
  }
`;

export const Item = styled.div`
  display: flex;
  align-items: baseline;
  padding: 6px 12px 0;
  & > div.data {
    flex: 1;
    & > .accordian-header {
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 8px;
      margin-top: 3px;
      margin-bottom: 12px;

      & > div.group-name {
        font-weight: 600;
        font-size: 14px;
        color: var(--color-elephant-850);
      }
    }

    & > div.group-options {
      margin-left: 22px;
      display: flex;
      align-items: center;
      margin-top: 12px;
      flex-wrap: wrap;
    }
  }
`;

export const Tag = styled(DivA11y)`
  cursor: pointer;
  background: #fafafb;
  margin: 0 8px 8px 0;
  border: 0.5px solid #bec9d5;
  border-radius: 2px;
  padding: 2px 12px;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  color: #12344d;
`;
